import React from "react";
import { FaWindows, FaApple, FaAndroid } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { detectOS } from "../../hooks/useSmartDownload";

const ICON_BY_OS = {
  windows: FaWindows,
  mac: FaApple,
  ios: FaApple,
  android: FaAndroid,
};

/**
 * Renders the icon matching the visitor's OS (Windows / Apple / Android),
 * falling back to a generic download icon when the OS is unknown.
 * Pass `os` to override detection; otherwise it auto-detects.
 */
const DownloadOSIcon = ({ className = "", os }) => {
  const key = os || detectOS();
  const Icon = ICON_BY_OS[key] || FiDownload;
  return <Icon className={className} />;
};

export default DownloadOSIcon;
